// import project from './image/project.png'
import max from '../pic/max.png'
import fyoutube from '../pic/fyoutube.png'
import healthkart from '../pic/healthkart.png'
import Dermstore from '../pic/Dermstore.png'
import movie from '../pic/movie.png'
import weather from '../pic/weather.jpg'

const Portfolio_data = [
  {
    id: 1,
    category: "Max-Fashion clone",
    totalLike: "600",
    title: "Max Fashion is an Indian fashion brand ",
    image: max,
    github:"https://github.com/rushig777/festive-crayon-1023",
    deployed:"https://clone-of-maxfashion-rushig777.vercel.app/",
    tech:"Tech used : React JS | Next JS | Mongo DB | Node JS "
  },
  {
    id: 2,
    category: "Youtube clone",
    totalLike: "750",
    title: "YouTube is an online video sharing and social media platform",
    image: fyoutube,
    github:"https://github.com/Surya737673/Youtube-clone",
    deployed:"https://reverent-wozniak-2d8364.netlify.app/",
    tech:"Tech used : Javasript | Rest API | HTML  |  CSS "
  },
  {
    id: 3,
    category: "Healthkart clone",
    totalLike: "630",
    title: "HealthKart is the easiest way to discover and shop health and fitness supplements",
    image: healthkart  ,
    github:"https://github.com/Surya737673/Healthkart-clone",
    deployed:"https://preeminent-crepe-9a703f.netlify.app/",
    tech:"Tech used : HTML | CSS | Javasript"
  },
  {
    id: 4,
    category: "Dermstore clone",
    totalLike: "360",
    title: "Dermstore is a skin care and beauty e-commerce site ",
    image: Dermstore,
    github:"https://github.com/Surya737673/DermStore",
    deployed:"https://beamish-tartufo-8757f9.netlify.app/",
    tech:"Tech used : React | Redux"
  },
  {
    id: 5,
    category: "Weather App",
    totalLike: "280",
    title: "Check your city's weather",
    image: weather,
    github:"https://github.com/Surya737673/Weather-app",
    deployed:"https://zen-beaver-136111.netlify.app/",
    tech:"Tech used : Javasript | Rest API  | HTML | CSS "
  },
  {
    id: 6,
    category: "Movie Search",
    totalLike: "690",
    title: "Discover Movies",
    image: movie,
    github:"https://github.com/Surya737673/Movies-search-app",
    deployed:"https://compassionate-wozniak-e8ca1d.netlify.app/",
    tech:"Tech used : Javasript | Rest API  | HTML | CSS "
  },
]
export default Portfolio_data
